import ContentPreview from './content_preview.ui.jsx';

import fetchTree, { depends, loader, group } from 'fetch-tree';

import { refreshContent, deleteContent } from '../actions/content';
import { contentLoader, lastPageLoader } from '../resources/content';
import { sectionLoader } from '../resources/section';

import { isInstructorInSection } from '../selectors/current_user';
import { selectCoverImage } from '../selectors/content';
import { selectOfflineContentStatus, isConnected } from '../selectors/offline';
import { countUnansweredQuestions } from '../selectors/markup';
import { fetchUnansweredCount } from '../actions/markup';
import { toggleOffline, cacheCover } from '../actions/offline.js';
import { hideSharingQA } from '../selectors/current_user';
import { setOrigin } from 'actions/content';

export const resources = group({
    content: depends([depends.prop('contentId')], contentLoader),
    lastPageRead: depends(['content'], lastPageLoader),
    section: depends(['content.section_id', 'content'], sectionLoader),
    isInstructor: depends(['section'], isInstructorInSection),
    hideSharingQA,
    unansweredCount: depends(
        ['isInstructor', 'content', 'hideSharingQA'],
        loader({
            lazy: true,
            id: (isInstructor, content) => `unanswered-${content.id}`,
            action(isInstructor, content, hideSharingQA) {
                // students don't have unanswered counts
                if (!isInstructor || hideSharingQA) {
                    return dispatch => Promise.resolve(null);
                }
                return fetchUnansweredCount(content);
            },
            selector(state, isInstructor, content) {
                // students don't have unanswered counts
                if (!isInstructor) {
                    return {
                        find() {
                            return 0;
                        },
                    };
                }

                return countUnansweredQuestions(state, content);
            },
        })
    ),
    coverUrl: depends(
        ['content', 'content.id'],
        loader({
            id: (_, id) => `cover-${id}`,
            action: cacheCover,
            selector: selectCoverImage,
        })
    ),
    linkType: depends(
        ['content.link_cover_override'],
        (state, link_cover_override) => {
            let linkType;
            if (link_cover_override) {
                if (link_cover_override.indexOf('vimeo') >= 0) {
                    linkType = 'vimeo';
                } else if (link_cover_override.indexOf('youtube') >= 0) {
                    linkType = 'youtube';
                } else {
                    linkType = link_cover_override.split(':')[0];
                }
            }
            return linkType;
        }
    ),
    offlineStatus: depends(['content.id'], (state, id) =>
        selectOfflineContentStatus(state, { id })
    ),
    isConnected,
});

export default fetchTree({
    component: ContentPreview,
    mapDispatchToProps: {
        refreshContent,
        deleteContent,
        toggleOffline,
        setOrigin,
    },
    resources,
});



// WEBPACK FOOTER //
// ./src/components/content_preview.jsx